(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-footer-signature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncVh = () => {
      const vh = window.innerHeight + 'px';
      document.querySelectorAll('.fh-footer-signature--fullscreen').forEach((el) => {
        el.style.setProperty('--fh-real-vh', vh);
      });
    };
    syncVh();
    window.addEventListener('resize', syncVh);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-media-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = Array.from(document.querySelectorAll('[data-fh-media-text]'));
    if (!sections.length) return;

    const syncVh = () => {
      const vh = window.innerHeight + 'px';
      document.querySelectorAll('.fh-media-text--fullscreen').forEach((el) => {
        el.style.setProperty('--fh-real-vh', vh);
      });
    };
    syncVh();
    window.addEventListener('resize', syncVh);

    sections.forEach((section) => {
      const video = section.querySelector('.fh-media-text__video');
      const button = section.querySelector('[data-fh-audio-toggle]');
      if (!video || !button) return;

      // Start muted by default to preserve autoplay behavior across browsers.
      video.muted = true;
      button.setAttribute('aria-pressed', 'false');

      button.addEventListener('click', async () => {
        const shouldUnmute = video.muted;
        video.muted = !shouldUnmute ? true : false;
        button.setAttribute('aria-pressed', shouldUnmute ? 'true' : 'false');
        button.setAttribute('aria-label', shouldUnmute ? 'Mute video' : 'Enable sound');

        if (shouldUnmute) {
          try {
            await video.play();
          } catch (error) {
            video.muted = true;
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', 'Enable sound');
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // G9 · Visor de ampliacion. Abre la foto que se esta viendo al ancho real
    // del archivo, con tope de 3200 px, y no la pide hasta ese momento. Un
    // clic alterna entre encajada y tamaño real; arrastrando se recorre, y la
    // rueda acerca y aleja. No amplia por encima del 100% del fichero: pasado
    // ese punto solo se veria el mismo grano mas grande.
    function initZoom(section, mainMediaEl) {
      const capa = section.querySelector('[data-fh-zoom]');
      const img = section.querySelector('[data-fh-zoom-img]');
      const abrir = section.querySelector('[data-fh-zoom-open]');
      const cerrar = section.querySelector('[data-fh-zoom-close]');
      if (!capa || !img || !abrir || !cerrar) return;

      // La escala 1 es la foto ya encajada en la pantalla (el navegador la
      // ajusta con max-width/max-height). El tope es lo que da el fichero:
      // ancho real entre ancho en pantalla. Para una foto pequeña eso es 1 y
      // el visor simplemente no amplía, que es lo honesto.
      let escala = 1;
      let escalaMax = 1;
      let x = 0;
      let y = 0;
      let arrastre = null;
      let quienAbrio = null;

      const activo = () =>
        mainMediaEl.querySelector('.fh-product__media-item--active') ||
        mainMediaEl.querySelector('.fh-product__media-item');

      const pintar = () => {
        img.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + escala + ')';
        capa.toggleAttribute('data-ampliado', escala > 1.01);
      };

      // Mantiene la foto dentro de la pantalla: si cabe entera se queda
      // centrada, y si no, no se puede arrastrar más allá de sus bordes.
      const encajar = () => {
        const anchoVista = capa.clientWidth;
        const altoVista = capa.clientHeight;
        const anchoImg = img.offsetWidth * escala;
        const altoImg = img.offsetHeight * escala;
        const izq = img.offsetLeft;
        const arr = img.offsetTop;
        x = anchoImg <= anchoVista
          ? (anchoVista - anchoImg) / 2 - izq
          : Math.min(-izq, Math.max(anchoVista - anchoImg - izq, x));
        y = altoImg <= altoVista
          ? (altoVista - altoImg) / 2 - arr
          : Math.min(-arr, Math.max(altoVista - altoImg - arr, y));
      };

      const zoomA = (nueva, hacia) => {
        const antes = escala;
        escala = Math.min(Math.max(nueva, 1), escalaMax);
        if (hacia && antes) {
          const k = escala / antes;
          x = hacia.x - (hacia.x - x) * k;
          y = hacia.y - (hacia.y - y) * k;
        }
        encajar();
        pintar();
      };

      const medir = () => {
        escalaMax = img.offsetWidth ? Math.max(1, img.naturalWidth / img.offsetWidth) : 1;
      };

      const abrirVisor = () => {
        const item = activo();
        const src = item && item.dataset.fhZoomSrc;
        if (!src) return;
        quienAbrio = document.activeElement;
        img.src = src;
        img.alt = item.dataset.fhZoomAlt || '';
        img.style.transform = '';
        capa.hidden = false;
        document.body.style.overflow = 'hidden';
        const listo = () => {
          escala = 1;
          x = 0;
          y = 0;
          medir();
          encajar();
          pintar();
        };
        if (img.complete && img.naturalWidth) listo();
        else img.addEventListener('load', listo, { once: true });
        cerrar.focus();
      };

      const cerrarVisor = () => {
        capa.hidden = true;
        capa.removeAttribute('data-ampliado');
        document.body.style.overflow = '';
        img.removeAttribute('src');
        if (quienAbrio && quienAbrio.focus) quienAbrio.focus();
      };

      abrir.addEventListener('click', abrirVisor);
      cerrar.addEventListener('click', cerrarVisor);

      // La propia foto abre el visor: es lo que se intenta antes de buscar un
      // boton. El boton se queda como pista visual de que se puede.
      mainMediaEl.addEventListener('click', (e) => {
        if (e.target.closest('[data-fh-zoom-open]')) return;
        if (e.target.closest('video')) return;           // el video tiene sus controles
        const item = e.target.closest('.fh-product__media-item');
        if (item && item.dataset.fhZoomSrc) abrirVisor();
      });

      capa.addEventListener('click', (e) => {
        if (e.target === capa) { cerrarVisor(); return; }
        if (e.target !== img || arrastre) return;
        const r = capa.getBoundingClientRect();
        zoomA(escala > 1.01 ? 1 : escalaMax, { x: e.clientX - r.left, y: e.clientY - r.top });
      });

      capa.addEventListener('wheel', (e) => {
        if (capa.hidden) return;
        e.preventDefault();
        const r = capa.getBoundingClientRect();
        zoomA(escala * (e.deltaY < 0 ? 1.15 : 0.87), { x: e.clientX - r.left, y: e.clientY - r.top });
      }, { passive: false });

      img.addEventListener('pointerdown', (e) => {
        if (escala <= 1.01) return;
        arrastre = { px: e.clientX, py: e.clientY, movido: false };
        capa.setAttribute('data-arrastrando', '');
        img.setPointerCapture(e.pointerId);
      });

      img.addEventListener('pointermove', (e) => {
        if (!arrastre) return;
        x += e.clientX - arrastre.px;
        y += e.clientY - arrastre.py;
        arrastre.px = e.clientX;
        arrastre.py = e.clientY;
        arrastre.movido = true;
        encajar();
        pintar();
      });

      const soltar = () => {
        if (!arrastre) return;
        const movido = arrastre.movido;
        capa.removeAttribute('data-arrastrando');
        // El clic con el que acaba el arrastre no debe contar como clic de zoom.
        if (movido) setTimeout(() => { arrastre = null; }, 0);
        else arrastre = null;
      };
      img.addEventListener('pointerup', soltar);
      img.addEventListener('pointercancel', soltar);

      document.addEventListener('keydown', (e) => {
        if (capa.hidden) return;
        if (e.key === 'Escape') cerrarVisor();
        // El visor es una sola parada de tabulación: el foco no se escapa
        // por detrás de la capa mientras está abierta.
        if (e.key === 'Tab') { e.preventDefault(); cerrar.focus(); }
      });

      window.addEventListener('resize', () => {
        if (capa.hidden || !img.naturalWidth) return;
        medir();
        zoomA(escala);
      });
    }

    function initProduct(section) {
      const sectionId = section.dataset.sectionId;
      const thumbsEl = section.querySelector('#fh-thumbnails-' + sectionId);
      const mainMediaEl = section.querySelector('#fh-main-media-' + sectionId);

      if (!thumbsEl || !mainMediaEl) return;

      initZoom(section, mainMediaEl);

      // Thumbnail gallery
      const thumbs = thumbsEl.querySelectorAll('.fh-product__thumb');
      const mediaItems = mainMediaEl.querySelectorAll('.fh-product__media-item');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.dataset.index, 10);
          thumbs.forEach(t => t.classList.remove('fh-product__thumb--active'));
          mediaItems.forEach(m => m.classList.remove('fh-product__media-item--active'));
          thumb.classList.add('fh-product__thumb--active');
          if (mediaItems[idx]) mediaItems[idx].classList.add('fh-product__media-item--active');
        });
      });

      // Variant selector
      const form = section.querySelector('.fh-product__form');
      if (!form) return;

      const variantInput = form.querySelector('#fh-variant-id-' + sectionId);
      const optionBtns = form.querySelectorAll('.fh-product__option-btn');
      const addBtn = section.querySelector('.fh-product__add-btn');
      const variantMetafieldsEl = document.getElementById('fh-variant-metafields-' + sectionId);

      const productData = JSON.parse(section.dataset.variants || '[]');
      const variantMetafields = variantMetafieldsEl ? JSON.parse(variantMetafieldsEl.textContent || '{}') : {};

      function getSelectedOptions() {
        const opts = {};
        optionBtns.forEach(btn => {
          if (btn.classList.contains('fh-product__option-btn--active')) {
            opts[btn.dataset.optionPosition] = btn.dataset.value;
          }
        });
        return opts;
      }

      function findVariant(selectedOpts) {
        return productData.find(v => {
          return (
            (!selectedOpts['1'] || v.option1 === selectedOpts['1']) &&
            (!selectedOpts['2'] || v.option2 === selectedOpts['2']) &&
            (!selectedOpts['3'] || v.option3 === selectedOpts['3'])
          );
        });
      }

      function updatePrice(variant) {
        if (!variant) return;
        const priceEl = section.querySelector('#fh-price-' + sectionId);
        if (!priceEl) return;
        const currency = section.dataset.currency || 'EUR';
        const formatted = variant.price / 100;
        priceEl.innerHTML = '<span class="price-item">' + new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: currency }).format(formatted) + '</span>';
      }

      function updateGallery(variant) {
        if (!variant || !variant.featured_media) return;
        const mediaId = variant.featured_media.position - 1;
        thumbs.forEach(t => t.classList.remove('fh-product__thumb--active'));
        mediaItems.forEach(m => m.classList.remove('fh-product__media-item--active'));
        if (thumbs[mediaId]) thumbs[mediaId].classList.add('fh-product__thumb--active');
        if (mediaItems[mediaId]) mediaItems[mediaId].classList.add('fh-product__media-item--active');
      }

      function updateAccordions(variant) {
        if (!variant) return;
        const variantData = variantMetafields[String(variant.id)] || {};
        // Cualquier bloque con metacampo, sea acordeon o la descripcion suelta.
        const dynamicAccordions = section.querySelectorAll('[data-metafield-key]');

        dynamicAccordions.forEach((accordion) => {
          const key = accordion.dataset.metafieldKey;
          const contentEl =
            accordion.querySelector('[data-fh-content]') ||
            accordion.querySelector('.fh-accordion__content');
          if (!contentEl) return;

          const variantHtml = variantData[key] || '';
          const fallbackHtml = contentEl.dataset.fallbackContent || '';

          if (variantHtml.trim() !== '') {
            contentEl.innerHTML = variantHtml;
            accordion.hidden = false;
          } else if (fallbackHtml.trim() !== '') {
            contentEl.innerHTML = fallbackHtml;
            accordion.hidden = false;
          } else {
            const hasLegalLinks = accordion.querySelector('[data-fh-legal]') !== null;
            contentEl.innerHTML = '';
            accordion.hidden = !hasLegalLinks;
            if (!hasLegalLinks) accordion.open = false;
          }
        });
      }

      const initialVariant = productData.find(v => String(v.id) === String(variantInput.value));
      if (initialVariant) {
        updateAccordions(initialVariant);
      }

      optionBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const position = btn.dataset.optionPosition;
          // Deactivate siblings of same position
          form.querySelectorAll('[data-option-position="' + position + '"]').forEach(b => {
            b.classList.remove('fh-product__option-btn--active');
          });
          btn.classList.add('fh-product__option-btn--active');

          const selectedOpts = getSelectedOptions();
          const variant = findVariant(selectedOpts);

          if (variant) {
            variantInput.value = variant.id;
            updatePrice(variant);
            updateGallery(variant);
            updateAccordions(variant);
            if (addBtn) {
              if (variant.available) {
                addBtn.disabled = false;
                addBtn.classList.remove('fh-product__add-btn--sold-out');
                addBtn.textContent = addBtn.dataset.labelAvailable || addBtn.textContent;
              } else {
                addBtn.disabled = true;
                addBtn.classList.add('fh-product__add-btn--sold-out');
                addBtn.textContent = addBtn.dataset.labelSoldOut || addBtn.textContent;
              }
            }
          }
        });
      });

      // ---------------------------------------------------------------
      // Graduación y grabado (FH 2.1)
      // ---------------------------------------------------------------
      const gr = section.querySelector('[data-fh-graduacion]');
      if (gr) {
        const GR_ALLOWED = /^[A-Za-z0-9 .\-ÁÉÍÓÚÜÑáéíóúüñÀÈÌÒÙàèìòùÂÊÎÔÛâêîôûÄËÏÖäëïöÇç]*$/;

        const grPosition = parseInt(gr.dataset.grPosition, 10);
        const grValues = {
          no: gr.dataset.grValSin,
          si: gr.dataset.grValCon,
          grabado: gr.dataset.grValGrabado
        };
        const maxChars = parseInt(gr.dataset.grMaxChars, 10) || 15;
        const maxBytes = (parseFloat(gr.dataset.grMaxMb) || 10) * 1024 * 1024;
        const uploadUrl = (gr.dataset.grUploadUrl || '').trim();

        const proxy = gr.querySelector('[data-gr-proxy]');
        const panelGrad = gr.querySelector('[data-gr-panel="graduacion"]');
        const panelGrabado = gr.querySelector('[data-gr-panel="grabado"]');
        const fieldTexto = gr.querySelector('[data-gr-field="texto"]');
        const fieldArchivo = gr.querySelector('[data-gr-field="archivo"]');
        const fieldGrabado = gr.querySelector('[data-gr-field="grabado"]');
        const inputTexto = gr.querySelector('[data-gr-texto]');
        const inputFile = gr.querySelector('[data-gr-file]');
        const fileStatus = gr.querySelector('[data-gr-file-status]');
        const fileStatusDefault = fileStatus ? fileStatus.textContent : '';
        const recetaFlag = gr.querySelector('[data-gr-receta-flag]');
        const recetaRef = gr.querySelector('[data-gr-receta-ref]');
        const inputGrabado = gr.querySelector('[data-gr-grabado-text]');
        const counter = gr.querySelector('[data-gr-counter]');
        const errorEl = gr.querySelector('[data-gr-error]');

        let state = { grad: 'no', via: '', grabado: 'no' };

        function money(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'es', {
            style: 'currency',
            currency: section.dataset.currency || 'EUR'
          }).format(cents / 100);
        }

        // Precios de los tres valores de lentes, para la combinación actual del resto de opciones
        function pricesByGrValue() {
          const opts = getSelectedOptions();
          const idx = grPosition - 1;
          const out = {};
          productData.forEach(v => {
            const vOpts = [v.option1, v.option2, v.option3];
            let matches = true;
            for (let p = 1; p <= 3; p++) {
              if (p === grPosition) continue;
              if (opts[String(p)] && vOpts[p - 1] !== opts[String(p)]) matches = false;
            }
            if (matches && vOpts[idx]) out[vOpts[idx]] = v.price;
          });
          return out;
        }

        function updateDeltas() {
          const p = pricesByGrValue();
          const base = p[grValues.no];
          const con = p[grValues.si];
          const grab = p[grValues.grabado];
          const elGrad = gr.querySelector('[data-gr-delta="graduacion"]');
          const elGrab = gr.querySelector('[data-gr-delta="grabado"]');
          if (elGrad) {
            elGrad.textContent = (base != null && con != null && con > base) ? '+' + money(con - base) : '';
          }
          if (elGrab) {
            elGrab.textContent = (con != null && grab != null && grab > con) ? '+' + money(grab - con) : '';
          }
        }

        function targetGrValue() {
          if (state.grad !== 'si') return grValues.no;
          return state.grabado === 'si' ? grValues.grabado : grValues.si;
        }

        function applyVariant() {
          proxy.dataset.value = targetGrValue();
          const variant = findVariant(getSelectedOptions());
          if (variant) {
            variantInput.value = variant.id;
            updatePrice(variant);
            updateAccordions(variant);
            if (addBtn) {
              addBtn.disabled = !variant.available;
              addBtn.classList.toggle('fh-product__add-btn--sold-out', !variant.available);
              // El texto también, o el botón queda deshabilitado diciendo "agregar al
              // carrito" y parece roto en lugar de agotado
              const etiqueta = variant.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut;
              if (etiqueta) addBtn.textContent = etiqueta;
            }
          }
          updateDeltas();
        }

        function setError(msg) {
          if (!errorEl) return;
          errorEl.textContent = msg || '';
          errorEl.hidden = !msg;
        }

        function syncUI() {
          const grad = state.grad === 'si';
          panelGrad.hidden = !grad;
          panelGrabado.hidden = !grad;

          fieldTexto.hidden = !(grad && state.via === 'texto');
          fieldArchivo.hidden = !(grad && state.via === 'archivo');
          fieldGrabado.hidden = !(grad && state.grabado === 'si');

          // Sólo se envían las propiedades aplicables: el resto van deshabilitadas
          inputTexto.disabled = fieldTexto.hidden;
          inputGrabado.disabled = fieldGrabado.hidden;
          const hasRef = !!(recetaRef && recetaRef.value);
          if (recetaFlag) recetaFlag.disabled = fieldArchivo.hidden || !hasRef;
          if (recetaRef) recetaRef.disabled = fieldArchivo.hidden || !hasRef;

          if (!grad) {
            state.via = '';
            gr.querySelectorAll('[data-gr-via]').forEach(b => b.classList.remove('fh-graduacion__btn--active'));
          }
          setError('');
        }

        gr.querySelectorAll('[data-gr-grad]').forEach(btn => {
          btn.addEventListener('click', () => {
            state.grad = btn.dataset.grGrad;
            gr.querySelectorAll('[data-gr-grad]').forEach(b => b.classList.remove('fh-graduacion__btn--active'));
            btn.classList.add('fh-graduacion__btn--active');
            if (state.grad !== 'si') {
              state.grabado = 'no';
              gr.querySelectorAll('[data-gr-grabado]').forEach(b => {
                b.classList.toggle('fh-graduacion__btn--active', b.dataset.grGrabado === 'no');
              });
            }
            syncUI();
            applyVariant();
          });
        });

        gr.querySelectorAll('[data-gr-via]').forEach(btn => {
          btn.addEventListener('click', () => {
            state.via = btn.dataset.grVia;
            gr.querySelectorAll('[data-gr-via]').forEach(b => b.classList.remove('fh-graduacion__btn--active'));
            btn.classList.add('fh-graduacion__btn--active');
            syncUI();
          });
        });

        gr.querySelectorAll('[data-gr-grabado]').forEach(btn => {
          btn.addEventListener('click', () => {
            state.grabado = btn.dataset.grGrabado;
            gr.querySelectorAll('[data-gr-grabado]').forEach(b => b.classList.remove('fh-graduacion__btn--active'));
            btn.classList.add('fh-graduacion__btn--active');
            syncUI();
            applyVariant();
          });
        });

        // Contador y filtrado de caracteres del grabado
        if (inputGrabado && counter) {
          inputGrabado.addEventListener('input', () => {
            let v = inputGrabado.value;
            if (!GR_ALLOWED.test(v)) {
              v = v.split('').filter(c => GR_ALLOWED.test(c)).join('');
              inputGrabado.value = v;
              setError('Sólo se admiten letras, números, espacios, acentos, guiones y puntos.');
            } else {
              setError('');
            }
            if (v.length > maxChars) {
              inputGrabado.value = v.slice(0, maxChars);
            }
            counter.textContent = inputGrabado.value.length + '/' + maxChars;
          });
        }

        // Subida de la receta al servidor propio
        if (inputFile) {
          inputFile.addEventListener('change', () => {
            const file = inputFile.files && inputFile.files[0];
            if (recetaRef) recetaRef.value = '';
            syncUI();
            if (!file) {
              fileStatus.textContent = fileStatusDefault;
              fileStatus.className = 'fh-graduacion__hint';
              return;
            }

            const okType = /\.(pdf|jpe?g|png)$/i.test(file.name);
            if (!okType) {
              fileStatus.textContent = 'Formato no admitido. Sube un PDF, JPG o PNG.';
              fileStatus.className = 'fh-graduacion__hint fh-graduacion__hint--error';
              inputFile.value = '';
              return;
            }
            if (file.size > maxBytes) {
              fileStatus.textContent = 'El archivo supera el tamaño máximo de ' + gr.dataset.grMaxMb + ' MB.';
              fileStatus.className = 'fh-graduacion__hint fh-graduacion__hint--error';
              inputFile.value = '';
              return;
            }

            if (!uploadUrl) {
              fileStatus.textContent = 'La subida de recetas todavía no está activa. Configura el endpoint en el editor de temas.';
              fileStatus.className = 'fh-graduacion__hint fh-graduacion__hint--error';
              return;
            }

            fileStatus.textContent = 'Subiendo receta…';
            fileStatus.className = 'fh-graduacion__hint';

            const body = new FormData();
            body.append('file', file);
            fetch(uploadUrl, { method: 'POST', body: body })
              .then(r => r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)))
              .then(data => {
                if (!data || !data.ref) throw new Error('Respuesta sin referencia');
                recetaRef.value = data.ref;
                fileStatus.textContent = 'Receta recibida (' + data.ref + ').';
                fileStatus.className = 'fh-graduacion__hint fh-graduacion__hint--ok';
                syncUI();
              })
              .catch(() => {
                recetaRef.value = '';
                fileStatus.textContent = 'No hemos podido subir la receta. Inténtalo de nuevo o escríbenos tu graduación.';
                fileStatus.className = 'fh-graduacion__hint fh-graduacion__hint--error';
                syncUI();
              });
          });
        }

        // Validación antes de añadir al carrito
        form.addEventListener('submit', (e) => {
          if (state.grad !== 'si') return;
          if (!state.via) {
            e.preventDefault();
            setError('Elige cómo quieres darnos tu graduación.');
            return;
          }
          if (state.via === 'texto' && !inputTexto.value.trim()) {
            e.preventDefault();
            setError('Escribe tu graduación para continuar.');
            return;
          }
          if (state.via === 'archivo' && !(recetaRef && recetaRef.value)) {
            e.preventDefault();
            setError('Adjunta tu receta para continuar.');
            return;
          }
          if (state.grabado === 'si' && !inputGrabado.value.trim()) {
            e.preventDefault();
            setError('Escribe el texto que quieres grabar.');
            return;
          }
        });

        // Recalcular recargos al cambiar Day-time / Night-time
        optionBtns.forEach(btn => {
          if (btn.dataset.grProxy === undefined && btn.dataset.optionPosition) {
            btn.addEventListener('click', () => { applyVariant(); });
          }
        });

        // Estado inicial coherente con la variante que Shopify haya seleccionado,
        // de modo que un enlace con ?variant= se respete en lugar de forzarse a "sin graduación"
        (function initState() {
          const current = productData.find(v => String(v.id) === String(variantInput.value));
          const currentGr = current ? [current.option1, current.option2, current.option3][grPosition - 1] : null;
          if (currentGr === grValues.grabado) {
            state.grad = 'si';
            state.grabado = 'si';
          } else if (currentGr === grValues.si) {
            state.grad = 'si';
            state.grabado = 'no';
          }
          gr.querySelectorAll('[data-gr-grad]').forEach(b => {
            b.classList.toggle('fh-graduacion__btn--active', b.dataset.grGrad === state.grad);
          });
          gr.querySelectorAll('[data-gr-grabado]').forEach(b => {
            b.classList.toggle('fh-graduacion__btn--active', b.dataset.grGrabado === state.grabado);
          });
          proxy.dataset.value = targetGrValue();
        })();

        syncUI();
        updateDeltas();
      }
    }

    document.querySelectorAll('.fh-product[data-section-id]').forEach(initProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-returns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fh-returns]').forEach(function (root) {
      var endpoint = (root.dataset.endpoint || '').trim();
      var labelUrl = (root.dataset.labelUrl || '').trim();
      var pasoDatos = root.querySelector('[data-step="datos"]');
      var pasoAviso = root.querySelector('[data-step="aviso"]');
      var inputOrder = root.querySelector('[data-field="order"]');
      var inputEmail = root.querySelector('[data-field="email"]');
      var errorEl = root.querySelector('[data-error]');
      var statusEl = root.querySelector('[data-status]');

      function error(msg) {
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      }

      function estado(msg, clase) {
        statusEl.textContent = msg || '';
        statusEl.className = 'fh-returns__status' + (clase ? ' fh-returns__status--' + clase : '');
        statusEl.hidden = !msg;
      }

      root.querySelector('[data-action="continuar"]').addEventListener('click', function () {
        var pedido = inputOrder.value.trim();
        var correo = inputEmail.value.trim();

        if (!pedido) { error('Indica tu número de pedido.'); inputOrder.focus(); return; }
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(correo)) { error('Indica un correo electrónico válido.'); inputEmail.focus(); return; }

        error('');
        pasoDatos.hidden = true;
        pasoAviso.hidden = false;
        pasoAviso.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      root.querySelector('[data-action="descargar"]').addEventListener('click', function () {
        var datos = {
          orderName: inputOrder.value.trim(),
          customerEmail: inputEmail.value.trim()
        };

        // La descarga nunca se bloquea por un fallo del aviso: se abre igualmente
        // y se le indica al cliente que escriba a devoluciones si algo ha fallado.
        function descargar() {
          if (labelUrl) window.open(labelUrl, '_blank', 'noopener');
        }

        if (!endpoint) {
          descargar();
          estado('Etiqueta descargada.', 'ok');
          return;
        }

        estado('Preparando tu etiqueta…', null);

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(datos)
        })
          .then(function (r) {
            descargar();
            if (r.ok) {
              estado('Etiqueta descargada. Hemos registrado tu solicitud.', 'ok');
            } else {
              estado('Etiqueta descargada, pero no hemos podido registrar tu solicitud. Escríbenos a devoluciones@freehuman.global indicando tu número de pedido.', 'error');
            }
          })
          .catch(function () {
            descargar();
            estado('Etiqueta descargada, pero no hemos podido registrar tu solicitud. Escríbenos a devoluciones@freehuman.global indicando tu número de pedido.', 'error');
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-scroll-message"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    function splitIntoWordSpans(el) {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) {
        if (node.textContent.trim()) textNodes.push(node);
      }
      textNodes.forEach((textNode) => {
        const parts = textNode.textContent.split(/(\s+)/);
        const fragment = document.createDocumentFragment();
        parts.forEach((part) => {
          if (part.trim()) {
            const span = document.createElement('span');
            span.className = 'fh-word';
            span.textContent = part;
            fragment.appendChild(span);
          } else if (part) {
            fragment.appendChild(document.createTextNode(part));
          }
        });
        textNode.parentNode.replaceChild(fragment, textNode);
      });
    }

    const updateSection = (section) => {
      const textEl = section.querySelector('[data-fh-scroll-message-text]');
      if (!textEl) return;

      if (!textEl.dataset.fhWordsSplit) {
        splitIntoWordSpans(textEl);
        textEl.dataset.fhWordsSplit = 'true';
      }

      const words = textEl.querySelectorAll('.fh-word');
      const wordCount = words.length;
      if (!wordCount) return;

      const sectionRect = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const scrollRange = Math.max(section.offsetHeight - vh, 1);
      // Start the reveal slightly before the section fully reaches the top
      // to avoid a fully black transition gap.
      const revealLead = vh * 0.18;
      const scrolled = -sectionRect.top + revealLead;
      const progress = clamp(scrolled / scrollRange, 0, 1);

      words.forEach((word, i) => {
        const wordStart = i / wordCount;
        const overlapStart = Math.max(0, wordStart - 0.5 / wordCount);
        const wordEnd = (i + 1) / wordCount;
        const wordProgress = clamp((progress - overlapStart) / (wordEnd - overlapStart), 0, 1);
        word.style.opacity = wordProgress.toFixed(3);
      });
    };

    const sections = Array.from(document.querySelectorAll('[data-fh-scroll-message]'));
    if (!sections.length) return;

    let ticking = false;
    const updateAll = () => { sections.forEach(updateSection); ticking = false; };
    const requestTick = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateAll);
    };

    updateAll();
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    window.addEventListener('load', requestTick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-split-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function advanceColumn(column) {
      const cells = Array.from(column.querySelectorAll('.fh-split-carousel__cell'));
      if (cells.length < 2) return;
      const activeIndex = cells.findIndex((c) => c.classList.contains('is-active'));
      const next = (activeIndex + 1) % cells.length;
      cells[activeIndex].classList.remove('is-active');
      cells[next].classList.add('is-active');
    }

    function initColumns(section) {
      const columns = Array.from(section.querySelectorAll('.fh-split-carousel__column'));
      if (columns.length < 2) return;

      // Left column advances every 4s starting immediately
      // Right column starts 2s later → columns alternate every 2s
      setInterval(() => advanceColumn(columns[0]), 4000);
      setTimeout(() => setInterval(() => advanceColumn(columns[1]), 4000), 2000);
    }

    document.querySelectorAll('.section-fh-split-carousel').forEach(initColumns);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-text-image-split"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    function splitIntoWordSpans(el, className) {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node;

      while ((node = walker.nextNode())) {
        if (node.textContent.trim()) textNodes.push(node);
      }

      textNodes.forEach((textNode) => {
        const parts = textNode.textContent.split(/(\s+)/);
        const fragment = document.createDocumentFragment();

        parts.forEach((part) => {
          if (part.trim()) {
            const span = document.createElement('span');
            span.className = className;
            span.textContent = part;
            fragment.appendChild(span);
          } else if (part) {
            fragment.appendChild(document.createTextNode(part));
          }
        });

        textNode.parentNode.replaceChild(fragment, textNode);
      });
    }

    function applyWordProgress(words, progress, start, end) {
      const count = words.length;
      if (!count) return;

      const localProgress = clamp((progress - start) / (end - start), 0, 1);
      words.forEach((word, i) => {
        const wordStart = i / count;
        const overlapStart = Math.max(0, wordStart - 0.5 / count);
        const wordEnd = (i + 1) / count;
        const wordProgress = clamp((localProgress - overlapStart) / (wordEnd - overlapStart), 0, 1);
        word.style.opacity = wordProgress.toFixed(3);
      });
    }

    const updateSection = (section) => {
      const metaEls = section.querySelectorAll('[data-fh-split-meta]');
      const body = section.querySelector('[data-fh-split-body]');

      metaEls.forEach((metaEl) => {
        if (!metaEl.dataset.fhWordsSplit) {
          splitIntoWordSpans(metaEl, 'fh-split-word fh-split-word--meta');
          metaEl.dataset.fhWordsSplit = 'true';
        }
      });

      if (body && !body.dataset.fhWordsSplit) {
        splitIntoWordSpans(body, 'fh-split-word fh-split-word--body');
        body.dataset.fhWordsSplit = 'true';
      }

      section.dataset.fhRevealReady = 'true';

      const metaWords = section.querySelectorAll('.fh-split-word--meta');
      const bodyWords = section.querySelectorAll('.fh-split-word--body');

      const sectionRect = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const scrollRange = Math.max(section.offsetHeight - vh, 1);

      // M4 · El progreso arranca cuando la seccion asoma por abajo, y no
      // cuando ya la has dejado atras. Con lo anterior --sectionRect.top- el
      // progreso valia 0 mientras la seccion ocupaba la pantalla entera, asi
      // que la imagen seguia a opacidad 0 y el lector se encontraba una
      // pantalla en blanco que solo se llenaba si continuaba bajando. Medido
      // en la portada de la tienda: una pantalla al 0% de contenido.
      const entrada = vh * 0.85;
      const recorrido = scrollRange + entrada;
      const scrolled = clamp(entrada - sectionRect.top, 0, recorrido);
      const progress = clamp(scrolled / recorrido, 0, 1);

      // First reveal top texts, then reveal the main body text.
      applyWordProgress(metaWords, progress, 0.04, 0.42);
      applyWordProgress(bodyWords, progress, 0.42, 0.92);

      // Image fade-in: starts at 35% scroll progress, fully visible at 70%
      const imageEl = section.querySelector('[data-fh-split-image]');
      if (imageEl) {
        // Con el recorrido nuevo, la seccion esta del todo en pantalla hacia
        // el 0,44 de progreso: la imagen tiene que haber terminado de
        // aparecer antes de ese punto.
        const imgStart = 0.10;
        const imgEnd = 0.42;
        const imgOpacity = clamp((progress - imgStart) / (imgEnd - imgStart), 0, 1);
        imageEl.style.opacity = imgOpacity.toFixed(3);
      }
    };

    // Query DOM live on every frame – no cached array so it works even if
    // sections are added/enabled after initial page load (Customize editor).
    let ticking = false;
    const updateAll = () => {
      document.querySelectorAll('[data-fh-split-scroll]').forEach(updateSection);
      ticking = false;
    };
    const requestTick = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateAll);
    };

    // Replace previous handlers to avoid stale closures in Customize.
    if (window._fhSplitOnScroll) {
      window.removeEventListener('scroll', window._fhSplitOnScroll);
    }
    if (window._fhSplitOnResize) {
      window.removeEventListener('resize', window._fhSplitOnResize);
    }
    if (window._fhSplitOnLoad) {
      window.removeEventListener('load', window._fhSplitOnLoad);
    }

    window._fhSplitOnScroll = requestTick;
    window._fhSplitOnResize = requestTick;
    window._fhSplitOnLoad = requestTick;

    window.addEventListener('scroll', window._fhSplitOnScroll, { passive: true });
    window.addEventListener('resize', window._fhSplitOnResize);
    window.addEventListener('load', window._fhSplitOnLoad);

    // Re-init when the Customize editor reloads a section.
    if (window._fhSplitSectionLoad) {
      document.removeEventListener('shopify:section:load', window._fhSplitSectionLoad);
    }
    window._fhSplitSectionLoad = requestTick;
    document.addEventListener('shopify:section:load', window._fhSplitSectionLoad);

    // Initial run.
    requestTick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.hasLandingTransition = Boolean(this.header && this.header.querySelector('[data-fh-landing-enabled="true"]') && this.header.querySelector('.header-wrapper--fh-hidden'));
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.topRevealThreshold = 56;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onMouseMoveHandler = this.onMouseMove.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('mousemove', this.onMouseMoveHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('mousemove', this.onMouseMoveHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.hasLandingTransition && this.classList.contains('header-wrapper--fh-fixed')) {
        const threshold = (this.headerBounds.bottom || this.header.offsetHeight || 0) + 12;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          this.currentScrollTop = scrollTop;
          return;
        }

        if (scrollTop > this.currentScrollTop && scrollTop > threshold) {
          requestAnimationFrame(this.hideLandingHeader.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > threshold) {
          requestAnimationFrame(this.revealLandingHeader.bind(this));
        } else if (scrollTop <= threshold) {
          requestAnimationFrame(this.resetLandingHeader.bind(this));
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    onMouseMove(event) {
      if (this.headerIsAlwaysSticky) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerBottom = this.headerBounds.bottom || this.header.offsetHeight || 0;

      if (scrollTop <= headerBottom) return;

      if (event.clientY <= this.topRevealThreshold) {
        this.preventReveal = false;
        if (this.hasLandingTransition && this.classList.contains('header-wrapper--fh-fixed')) {
          requestAnimationFrame(this.revealLandingHeader.bind(this));
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    hideLandingHeader() {
      this.classList.add('header-wrapper--fh-scroll-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    revealLandingHeader() {
      this.classList.remove('header-wrapper--fh-scroll-hidden');
    }

    resetLandingHeader() {
      this.classList.remove('header-wrapper--fh-scroll-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function setupLandingHeaderReveal() {
    const sectionHeader = document.querySelector('.section-header');

    if (!sectionHeader) return;

    const landingHero = sectionHeader.querySelector('[data-fh-landing-enabled="true"]');
    const headerWrapper = sectionHeader.querySelector('.header-wrapper--fh-hidden');
    const carouselMergeTarget = document.querySelector('[data-fh-logo-merge-target="true"]');
    const heroLogo = landingHero ? landingHero.querySelector('.fh-landing__logo-link') : null;
    const headerLogoSlot = headerWrapper ? headerWrapper.querySelector('.header__heading-logo-wrapper') : null;

    if (!landingHero || !headerWrapper) return;

    const getHeroPhaseDistance = (heroHeight, headerHeight) => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const minDistance = isMobile ? 260 : 420;
      const viewportFactor = isMobile ? 0.62 : 0.9;
      return Math.max(heroHeight - headerHeight, Math.max(window.innerHeight * viewportFactor, minDistance));
    };

    let heroPhaseDistance = getHeroPhaseDistance(landingHero.offsetHeight, headerWrapper.offsetHeight);
    let carouselStartY = heroPhaseDistance;
    let carouselDockDistance = Math.max(window.innerHeight * 0.85, 520);
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const syncLandingViewportHeight = () => {
      const vh = window.innerHeight;
      landingHero.style.setProperty('--fh-viewport-height', `${vh}px`);
      landingHero.style.setProperty('--fh-landing-scroll-length', `${Math.round(vh * 1.8)}px`);
    };

    const updateLandingTransition = () => {
      const scrollY = window.scrollY;
      const heroProgress = clamp(scrollY / heroPhaseDistance, 0, 1);
      const carouselProgress = clamp((scrollY - carouselStartY) / carouselDockDistance, 0, 1);
      const handoffProgress = clamp((carouselProgress - 0.84) / 0.16, 0, 1);

      landingHero.style.setProperty('--fh-logo-progress', heroProgress.toFixed(4));
      landingHero.style.setProperty('--fh-logo-flow-progress', heroProgress.toFixed(4));
      landingHero.style.setProperty('--fh-logo-merge-progress', carouselProgress.toFixed(4));
      landingHero.style.setProperty('--fh-logo-handoff-progress', handoffProgress.toFixed(4));
      landingHero.style.setProperty('--fh-tagline-flow-progress', heroProgress.toFixed(4));
      landingHero.style.setProperty('--fh-tagline-fade-progress', carouselProgress.toFixed(4));
      headerWrapper.style.setProperty('--fh-header-logo-opacity', handoffProgress.toFixed(4));

      // Show dark backdrop once the header logo has fully taken over from the landing hero
      if (handoffProgress >= 0.9) {
        headerWrapper.classList.add('header-wrapper--fh-bg');
      } else {
        headerWrapper.classList.remove('header-wrapper--fh-bg');
      }
    };

    const recalculateThreshold = () => {
      syncLandingViewportHeight();

      const heroHeight = landingHero.offsetHeight;
      const headerHeight = headerWrapper.offsetHeight;
      heroPhaseDistance = getHeroPhaseDistance(heroHeight, headerHeight);

      if (carouselMergeTarget) {
        const carouselRect = carouselMergeTarget.getBoundingClientRect();
        carouselStartY = carouselRect.top + window.scrollY;
        carouselDockDistance = Math.max(carouselRect.height * 0.9, Math.max(window.innerHeight * 0.85, 520));
      } else {
        carouselStartY = heroPhaseDistance;
        carouselDockDistance = Math.max(window.innerHeight * 0.85, 520);
      }

      if (heroLogo && headerLogoSlot) {
        const targetRect = headerLogoSlot.getBoundingClientRect();
        // Header logo is horizontally centered in the layout; force mergeX = 0
        // to prevent hero logo from drifting off-center during the merge animation.
        const mergeX = 0;
        // Use the actual rendered width of the hero logo (not the raw setting value)
        // so the scale factor correctly reflects the visual size change.
        const sourceWidth = Math.max(heroLogo.offsetWidth, 1);
        const targetWidth = Math.max(targetRect.width, 1);
        const mergeScale = clamp(targetWidth / sourceWidth, 0.12, 1);

        landingHero.style.setProperty('--fh-logo-merge-x', '0px');
        landingHero.style.setProperty('--fh-logo-merge-scale', mergeScale.toFixed(4));
      }

      updateLandingTransition();
    };

    headerWrapper.classList.add('header-wrapper--fh-visible');
    headerWrapper.classList.add('header-wrapper--fh-fixed');

    syncLandingViewportHeight();
    recalculateThreshold();
    window.addEventListener('scroll', updateLandingTransition, { passive: true });
    window.addEventListener('resize', recalculateThreshold);
    window.addEventListener('load', recalculateThreshold);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupLandingHeaderReveal);
  } else {
    setupLandingHeaderReveal();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sectionHeader = document.querySelector('.section-header');

    if (!sectionHeader) return;

    const headerWrapper = sectionHeader.querySelector('.header-wrapper--fh-hidden');
    const menuDrawerDetails = sectionHeader.querySelector('#Details-menu-drawer-container');

    if (!headerWrapper || !menuDrawerDetails) return;

    const syncMenuState = () => {
      headerWrapper.classList.toggle('header-wrapper--fh-menu-open', menuDrawerDetails.open);
    };

    menuDrawerDetails.addEventListener('toggle', syncMenuState);
    syncMenuState();
  });

  } catch(e) { console.error(e); }
})();
})();
